<template>
  <div>
    <div id="bg"></div>

    <div class="preloader">
      <div class="lds-ripple">
        <div></div>
        <div></div>
      </div>
    </div>

    <div class="container site">
      <img src="../../public/img/simba_logo.png" alt="Logo" class="logo" :class="{logoTxtOnly:logoTxtOnly}" />
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  name: "site",
  data() {
    return {};
  },
  computed: {
    logoTxtOnly() {
      return this.$route.meta.logoTxtOnly
        ? this.$route.meta.logoTxtOnly
        : false;
    },
  },
};
</script>
<style scoped>
.container {
  text-align: center;
}
.logoTxtOnly{
  margin-bottom:30px;
  width:100px;
  height:100px;
}
</style>
